import { ref } from 'vue'

export const isRouteLoading = ref(false)
